import moment, { Moment } from "moment";

export function getInitStartDate(): Moment {
    if (moment().isBefore(moment().set({ hour: 17 }))) {
        return moment().set({ hour: 17, minute: 0 }).second(0);
    }
    if (moment().minute() >= 30) {
        return moment().minute(30).second(0);
    }
    return moment().minute(0).second(0);
}
